import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class ConsensusPayloadStackItem extends EquatableKeyStackItem {
    asConsensusPayload() {
        return this.value;
    }
}

//# sourceMappingURL=ConsensusPayloadStackItem.js.map
